// require('./bootstrap');
// import {Bootstrap} from 'bootstrap';

import {xsScroll} from './top-nav-xs.js';
import {mdScroll} from './top-nav-md.js';
import {openSideMenu, closeSideMenu} from './side-menu.js';
import AOS from 'aos';
import {Terms} from './application';
window.addEventListener('load', function(){
    AOS.init();
});
import {general} from './general.js';
// Flickity
import Flickity from 'flickity';

// glightbox
import GLightbox from 'glightbox';
window.lightbox = GLightbox();

// flickity
window.addEventListener('load', function(){
    const carousel = document.querySelector('.carousel');
    if(carousel){
        carousel.classList.remove('d-none');
        var flkty = new Flickity( '.carousel', {
            "wrapAround": true, "autoPlay": true
        });
    }
});


// navigation
// window.onscroll = function(){xsScroll()};
// window.onscroll = function(){mdScroll()};
window.addEventListener('scroll', xsScroll);
window.addEventListener('scroll', mdScroll);
// side menu
const sideMenuButton = document.querySelector('#side-menu-button');
const sideMenuCloseButton = document.querySelector('#side-menu-xs-close-button');
if(sideMenuButton){
    sideMenuButton.addEventListener('click', openSideMenu);
}
if(sideMenuCloseButton){
    sideMenuCloseButton.addEventListener('click', closeSideMenu);
}
const terms = new Terms;